import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import { LOCAL_ACTIONS, openSupportChat } from "../../agent/agentContract";

const CtaChipsBlock = observer(({ block }) => {
  const history = useHistory();

  const handleClick = chip => {
    if (chip.actionId === LOCAL_ACTIONS.NAVIGATE && chip.path) {
      history.push(chip.path);
    }
    if (chip.actionId === LOCAL_ACTIONS.CONTACT_SUPPORT) {
      openSupportChat();
    }
    copilotStore.clickCta(block.id, chip);
  };

  return (
    <div className="copilotCtaChips">
      {(block.chips || []).map(chip => {
        const consumed =
          block.clickedActionId && block.clickedActionId === chip.actionId;
        // Local chips (view table, navigate) stay usable after an agent
        // action from the same row has been consumed.
        const isLocal =
          chip.actionId === LOCAL_ACTIONS.VIEW_TABLE ||
          chip.actionId === LOCAL_ACTIONS.NAVIGATE ||
          chip.actionId === LOCAL_ACTIONS.CONTACT_SUPPORT;
        return (
          <button
            type="button"
            key={chip.actionId + (chip.label || "")}
            className={`copilotCtaChips__chip ${
              chip.style === "primary" ? "primary" : ""
            } ${consumed ? "consumed" : ""}`}
            disabled={
              copilotStore.streaming ||
              (Boolean(block.clickedActionId) && !isLocal)
            }
            onClick={() => handleClick(chip)}
          >
            {chip.icon && !consumed && (
              <i className="material-icons-outlined">{chip.icon}</i>
            )}
            <span>{chip.label}</span>
            {consumed && <i className="material-icons-outlined">check</i>}
          </button>
        );
      })}
    </div>
  );
});

export default CtaChipsBlock;
